import request from "@/utils/request";

/**
 * [查询][分页]获取问题标签列表
 * @param params     查询条件
 */
export const getBaseDataIssueTagList = (params) => {
    return request.get(`/baseDataIssueTag/page`, { params });
}

/**
 * [查询][分页]获取物料分类表
 * @param params     查询条件
 */
export const getBaseDataMaterialCategoryList = (params) => {
    return request.get(`/baseDataMaterialCategory/page`, { params });
}

/**
 * [查询][分页]获取物料信息表
 * @param params     查询条件
 */
export const getBaseDataMaterialInfoList = (params) => {
    return request.get(`/baseDataMaterialInfo/page`, { params });
}

/**
 * [查询][分页]获取操作方式表
 * @param params     查询条件
 */
export const getBaseDataOperationMethodList = (params) => {
    return request.get(`/baseDataOperationMethod/page`, { params });
}

/**
 * [查询][分页]获取操作描述表
 * @param params     查询条件
 */
export const getBaseDataOperationDescriptionList = (params) => {
    return request.get(`/baseDataOperationDescription/page`, { params });
}

/**
 * [查询][分页]获取虫害类型表
 * @param params     查询条件
 */
export const getBaseDataPestTypeList = (params) => {
    return request.get(`/baseDataPestType/page`, { params });
}

/**
 * [查询][分页]获取区域管理表
 * @param params     查询条件
 */
export const getBaseDataRegionManagementList = (params) => {
    return request.get(`/baseDataRegionManagement/page`, { params });
}

/**
 * [查询][列表]获取区域管理表
 */
export const getBaseDataRegionManagementAll = () => {
    return request.get(`/baseDataRegionManagement/list`);
}

/**
 * [查询][分页]获取风险类型表
 * @param params     查询条件
 */
export const getBaseDataRiskTypeList = (params) => {
    return request.get(`/baseDataRiskType/page`, { params });
}

/**
 * [查询][分页]获取门店集团定制配置表
 * @param params     查询条件
 */
export const getBaseDataStoreCustomConfigList = (params) => {
    return request.get(`/baseDataStoreCustomConfig/page`, { params });
}

/**
 * [查询][列表]获取所有基础信息
 */
export const getAllBaseData = () => {
    return request.get(`/baseData/all`);
}

/**
 * [查询][列表]获取初始化基础数据
 */
export const getInitBaseData = () => {
    return request.get(`/baseData/init`);
}